import { useState } from "react";
import { apiClient } from "../api/client";

export const AuthErrorCode = {
  WRONG_PASSWORD: "WRONG_PASSWORD",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
  REQUIRES_RECENT_LOGIN: "REQUIRES_RECENT_LOGIN",
  WEAK_PASSWORD: "WEAK_PASSWORD",
  EMAIL_IN_USE: "EMAIL_IN_USE",
  NETWORK_ERROR: "NETWORK_ERROR",
  UNKNOWN: "UNKNOWN",
};

export async function changePassword(currentPassword, newPassword) {
  try {
    await apiClient.post("/auth/change-password", {
      currentPassword,
      newPassword,
    });
  } catch (err) {
    if (err.code === AuthErrorCode.WRONG_PASSWORD) {
      throw {
        code: AuthErrorCode.WRONG_PASSWORD,
        message: "Current password is incorrect.",
      };
    }
    throw {
      code: AuthErrorCode.UNKNOWN,
      message: err.message || "Failed to change password.",
    };
  }
}

export function useChangePassword() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  async function run(currentPassword, newPassword) {
    setBusy(true);
    setError(null);
    setSuccess(false);
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  function reset() {
    setError(null);
    setSuccess(false);
  }

  return { changePassword: run, busy, error, success, reset };
}
